"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColorsForInitials = getColorsForInitials;
exports.StyledPortraitContainer = exports.StyledIcon = exports.StyledCustomImg = exports.StyledPortraitGravatar = exports.StyledPortraitInitialsImg = exports.StyledPortraitInitials = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _icon = _interopRequireDefault(require("../icon"));

var _portrait = require("./portrait.config");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stylingForSize({
  size
}) {
  const params = _portrait.PORTRAIT_SIZE_PARAMS[size];

  if (!params) {
    return (0, _styledComponents.css)``;
  }

  return (0, _styledComponents.css)`
    width: ${params.dimensions}px;
    height: ${params.dimensions}px;
  `;
}

function stylingForShape({
  shape
}) {
  let cssString = "overflow: hidden;";
  if (shape === "square") cssString += "border-radius: 0px;";
  if (shape === "circle") cssString += "border-radius: 50%;";
  return (0, _styledComponents.css)`
    ${cssString}
  `;
}

function stylingForIcon({
  size,
  theme,
  darkBackground
}) {
  const params = _portrait.PORTRAIT_SIZE_PARAMS[size];

  if (!params) {
    return (0, _styledComponents.css)``;
  }

  let color = theme.portrait.border;
  let backgroundColor = theme.portrait.background;

  if (darkBackground) {
    color = theme.portrait.background;
    backgroundColor = theme.portrait.border;
  }

  return (0, _styledComponents.css)`
    background-color: ${backgroundColor};
    color: ${color};

    ${params.iconDimensions && (0, _styledComponents.css)`
      svg {
        width: ${params.iconDimensions}px;
        height: ${params.iconDimensions}px;
      }
    `}
  `;
}

function getColorsForInitials(theme, darkBackground) {
  return {
    textColor: darkBackground ? theme.portrait.background : theme.portrait.initials,
    bgColor: darkBackground ? theme.portrait.initials : theme.portrait.background
  };
}

const StyledPortraitInitials = _styledComponents.default.div`
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
  ${stylingForSize}
  ${stylingForShape}
  ${({
  theme
}) => (0, _styledComponents.css)`
      border: 1px solid ${theme.portrait.border};
    `}
`;
exports.StyledPortraitInitials = StyledPortraitInitials;
StyledPortraitInitials.propTypes = {
  theme: _propTypes.default.object,
  size: _propTypes.default.oneOf(_portrait.PORTRAIT_SIZES).isRequired,
  shape: _propTypes.default.oneOf(_portrait.PORTRAIT_SHAPES)
};
StyledPortraitInitials.defaultProps = {
  theme: _base.default,
  shape: "square"
};
const StyledPortraitInitialsImg = _styledComponents.default.img`
  display: block;
`;
exports.StyledPortraitInitialsImg = StyledPortraitInitialsImg;
StyledPortraitInitialsImg.propTypes = {
  src: _propTypes.default.string.isRequired,
  alt: _propTypes.default.string
};
const StyledPortraitGravatar = _styledComponents.default.img`
  display: inline-block;
  vertical-align: middle;
  ${stylingForSize}
  ${stylingForShape}
`;
exports.StyledPortraitGravatar = StyledPortraitGravatar;
StyledPortraitGravatar.propTypes = {
  shape: _propTypes.default.oneOf(_portrait.PORTRAIT_SHAPES),
  size: _propTypes.default.oneOf(_portrait.PORTRAIT_SIZES).isRequired,
  src: _propTypes.default.string.isRequired,
  alt: _propTypes.default.string
};
StyledPortraitGravatar.defaultProps = {
  theme: _base.default
};
const StyledCustomImg = _styledComponents.default.img`
  display: block;
  ${stylingForSize}
  ${stylingForShape}
`;
exports.StyledCustomImg = StyledCustomImg;
StyledCustomImg.propTypes = {
  src: _propTypes.default.string.isRequired,
  alt: _propTypes.default.string,
  shape: _propTypes.default.oneOf(_portrait.PORTRAIT_SHAPES),
  size: _propTypes.default.oneOf(_portrait.PORTRAIT_SIZES).isRequired
}; // && is used here to increase the specificity

const StyledIcon = (0, _styledComponents.default)(({
  darkBackground,
  ...rest
}) => /*#__PURE__*/_react.default.createElement(_icon.default, rest))`
  && {
    box-sizing: border-box;
    line-height: 14px;
    ${stylingForSize}
    ${stylingForIcon}
    ${stylingForShape}
    ${({
  theme
}) => (0, _styledComponents.css)`
        border: 1px dashed ${theme.portrait.border};
      `}
  }
`;
exports.StyledIcon = StyledIcon;
StyledIcon.propTypes = {
  darkBackground: _propTypes.default.bool,
  size: _propTypes.default.oneOf(_portrait.PORTRAIT_SIZES),
  shape: _propTypes.default.oneOf(_portrait.PORTRAIT_SHAPES),
  theme: _propTypes.default.object,
  type: _propTypes.default.string.isRequired
};
StyledIcon.defaultProps = {
  darkBackground: false,
  size: "M",
  shape: "square",
  theme: _base.default
};
const StyledPortraitContainer = _styledComponents.default.div`
  display: inline-block;
  ${({
  onClick
}) => onClick && "cursor: pointer"}
  ${_styledSystem.margin}
`;
exports.StyledPortraitContainer = StyledPortraitContainer;
StyledPortraitContainer.defaultProps = {
  theme: _base.default
};